import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48fd916f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex inline" }
const _hoisted_2 = { class: "btns flex" }

import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  emits: ["query", "reset"],
  setup(__props, { emit: emits }: { emit: ({(e: 'query'): void, (e: 'reset'): void }), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('query')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('reset')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})